import { cn } from "@/lib/utils";
import { ShieldCheck } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * OCT-22449 - the one note a non-admin sees in place of (or next to) a control
 * whose server route is admin-only (`withAdmin`). Every hidden or disabled
 * admin-only area reads the same, so users learn it means "a workspace admin
 * manages this", not "something is broken".
 *
 * Based on the note the API & Webhooks tab has shown since OCT-21990. Pass
 * `message` only when an area needs to say more (e.g. "Ask a workspace admin
 * to subscribe").
 *
 * @spec ILLEGAL E165
 */
export function AdminManagedNotice({
  message,
  className,
  testId = "notice-admin-managed",
}: {
  message?: string;
  className?: string;
  testId?: string;
}) {
  const { t } = useTranslation("common");
  return (
    <div
      role="note"
      className={cn(
        "flex items-start gap-2 rounded-md border border-border bg-muted/40 px-3 py-2 text-sm text-muted-foreground",
        className,
      )}
      data-testid={testId}
    >
      <ShieldCheck className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <span>
        {message
          ?? t("permissions.adminManaged", {
            defaultValue: "Managed by your workspace admins. Ask a workspace admin if you need a change here.",
          })}
      </span>
    </div>
  );
}
